<template>
    <v-text-field :value="value" :label="label" readonly hide-details active />
</template>

<script setup lang="ts">
defineProps<{
    value: string | number | null | undefined;
    label: string;
}>();
</script>
